const API_URL = process.env.REACT_APP_API_URL;



export async function signIn(email, password) {
    const response = await fetch(`${API_URL}/auth/signIn`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ email, password })
    });
  
    if (!response.ok) {
      const errorData = await response.json();
      throw new Error(errorData.message || 'Sign in failed');
    }
  
    const data = await response.json();
    return data; // { accessToken: '...' }
  }

export const changePassword = async (password, email, accessToken) => {
  const response = await fetch(`${API_URL}/auth/changePassword`, {
    method: "POST",
    headers: { 
        "Content-Type": "application/json",
        "x-cmdfw-jwt-token": `${accessToken}`,
     },
    body: JSON.stringify({
        password, email
    }),
  });

  return { response };
};

export const forgotPassword = async (email) => {
  const response = await fetch(`${API_URL}/auth/forgotPassword`, {
    method: "POST",
    headers: { 
        "Content-Type": "application/json",
     },
    body: JSON.stringify({ email }),
  });
  
  return { response };
};

export const verifyOTP = async (code, email) => {
  const response = await fetch(`${API_URL}/auth/verifyOTP`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code, email }),
  });

  const data = await response.json();
  return { response, data };
};

export const verifyNewMemberOTP = async (code, email) => {
  const response = await fetch(`${API_URL}/auth/verifyNewMemberOTP`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ code, email }),
  });

  const data = await response.json();
  return { response, data };
};
// Service signUp used to validate new User data
export const signUp = async (inputFields) => {
  const response = await fetch(`${API_URL}/auth/signUp`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify( inputFields ),
});

const data = await response.json();
return { response, data };
};

// Service signUp used to validate new User data
export const signUpHousehold = async (inputFields) => {
  const response = await fetch(`${API_URL}/auth/signUp/household`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify( inputFields ),
});

const data = await response.json();
return { response, data };
};


export const forgotUserName = async (mobileNumber) => {
  const response = await fetch(`${API_URL}/auth/forgotUserName`, {
  method: "POST",
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify({ mobileNumber }),
});

const data = await response.json();
return { response, data };
};